import { getFilteredOptions } from "helpers";
import { PartnerTypes } from "types";

const loadOptions = async search => {
	let options = await PartnerTypes.getOptions();

	const filteredOptions = getFilteredOptions(search, options);

	return {
		options: filteredOptions,
		hasMore: false,
	};
};

const partnerTypeColumn = () => ({
	name: "partnerType",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Partner Type",
});

export default partnerTypeColumn;
